const state = {
    emailcampaign: [],
    emailcampaignid: null,
    loading: false
};

export default state;